import { StateCreator } from 'zustand'
import { shallow } from 'zustand/shallow'
import { EventrGatewayAPI } from '../../data/gateway.api'
import { BoundStore, useBoundStore } from '../../state/bound.store'
interface ChatpoolState {}

interface ChatpoolActions {}
export interface IChatpoolSlice extends ChatpoolState, ChatpoolActions {}
export const createChatpoolSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    IChatpoolSlice
> = () => ({})

setTimeout(() => {
    useBoundStore.subscribe(
        (state) => ({
            orgConfig: state.orgConfig,
            selectedOrg: state.selectedOrg,
        }),
        (state) => {
            if (
                state.selectedOrg &&
                state.orgConfig?.isRocketChatInitialised === true
            ) {
                EventrGatewayAPI.rocketchat.ensureRunning(
                    state.selectedOrg.name
                )
            }
        },
        {
            fireImmediately: true,
            equalityFn: shallow,
        }
    )
}, 100)
